(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/_audience_guid.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "\n    <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "-item__info\">\n        <p class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "-item__name\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "</p>\n        <p class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "-item__guid\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "guid"), env.opts.autoescape);
output += "</p>\n        <input type=\"hidden\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "guid"), env.opts.autoescape);
output += "\" name=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "_id_list\">\n    </div>\n    <button class=\"comet-button comet-button--ghost comet-button--primary create-remove-guid\">\n        <svg class=\"comet-button__icon comet-button__icon--left\" aria-hidden=\"true\" focusable=\"false\">\n            <use xlink:href=\"";
output += runtime.suppressValue((lineno = 8, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#minus"])), env.opts.autoescape);
output += "\"></use>\n        </svg>\n    </button>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/_audience_guid", function(){});

